module.exports = __webpack_public_path__ + "fonts/WorkSans-Bold.63d2179.woff2";